import { ArrowBack, Close } from '../../icons';
import { styled } from '../../styles';
import { Button } from '../Button';
import { IconButton } from '../IconButton';
import { Typography } from '../Typography';

export const TourTooltipMobile = styled(Typography)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: theme.palette.blue[900],
  padding: theme.spacing(4),
  borderRadius: `${theme.shape.borderRadius * 4}px`,
  color: theme.palette.textWhite,
  maxWidth: '328px',
}));

export const TourStepTitleMobile = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  color: theme.palette?.grey?.['100'],
}));

export const TourStepActionsMobile = styled.div<{
  placement: 'top' | 'bottom';
}>(({ theme, placement }) => ({
  position: 'fixed',
  zIndex: theme.zIndex.onboardingMenu,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  width: '100%',
  padding: theme.spacing(0, 4),
  ...(placement === 'top' && { top: theme.spacing(10) }),
  ...(placement === 'bottom' && { bottom: theme.spacing(20) }),
}));

export const TourStepActionsTypographyMobile = styled(Typography)(
  ({ theme }) => ({
    color: theme.palette.textWhite,
  }),
);

export const TourTooltipButtonMobile = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.black[0],
  color: theme.palette.stateNormal,
  width: '100%',
  marginTop: theme.spacing(4),

  '&:hover': {
    backgroundColor: theme.palette.black[0],
    color: theme.palette.stateHover,
  },
}));

export const TourMobileCloseIconButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: theme.palette.surface4,
  padding: theme.spacing(1),
  borderRadius: `${theme.shape.borderRadius * 2}px`,
  marginLeft: 'auto',
}));

export const TourMobileCloseIcon = styled(Close)(({ theme }) => ({
  fill: theme.palette.text1,
}));

export const TourMobileBackIconButton = styled(IconButton)(({ theme }) => ({
  borderRadius: `${theme.shape.borderRadius * 2}px`,
  padding: theme.spacing(1),
  border: `1px solid ${theme.palette.black['800_a']}`,
}));

export const TourMobileBackIcon = styled(ArrowBack)(({ theme }) => ({
  fill: theme.palette.black['100'],
}));

export const TourMobileCounterWithCloseContainer = styled.div(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  alignItems: 'center',
}));
